import Cookies from 'js-cookie';
import { AUTH_TOKEN_KEY } from '../Constants/config.js';
import { apiPostRequest } from '../Helpers/Requests';
import endpoints from '../Helpers/Endpoints';
import { createOnboardingAppUrl } from '../Helpers/Actions';
import { clearLocalStorageKeepingGreetings } from './joinRequestGreeting';

/**
 * Handles user logout by:
 * 1. Calling the server-side logout endpoint to invalidate the session
 * 2. Clearing client-side authentication data
 * 3. Redirecting to the welcome page
 */
export const logoutHandler = async () => {
    try {
        // Call the server-side logout endpoint
        await apiPostRequest(endpoints.logout);
        // This is only a fallback to clear client-side authentication data
        // It will only work if the cookie is NOT set with the HttpOnly flag
        // HttpOnly cookies cannot be removed via JavaScript for security reasons
        Cookies.remove(AUTH_TOKEN_KEY, {
            path: '/',
            sameSite: 'strict',
            secure: process.env.NODE_ENV === 'production',
        });

        // Clear storage (except which join requests were already greeted)
        clearLocalStorageKeepingGreetings();
        sessionStorage.clear();

        // Redirect to welcome page
        window.location.href = createOnboardingAppUrl({ path: "/welcome", additionalParams: { logout: 'true' } });

    } catch (error) {
        console.error('Logout API error:', error);
        // Even if the API call fails, we still want to clear client-side data
    }


};

/**
 * Gets the authentication token
 * @returns {string|null} The authentication token or null if not found
 */
export const getAuthToken = () => {
    return Cookies.get(AUTH_TOKEN_KEY) || null;
};

/**
 * Sets the authentication token
 * @param {string} token - The authentication token
 * @param {Object} [options] - Cookie options
 */
export const setAuthToken = (token, options = {}) => {
    const defaultOptions = {
        path: '/',
        secure: process.env.NODE_ENV === 'production',
        sameSite: 'strict',
        ...options
    };

    Cookies.set(AUTH_TOKEN_KEY, token, defaultOptions);
};

/**
 * Checks if user is authenticated by verifying the presence of user_token
 * @returns {boolean} true if user is authenticated
 */
export const isAuthenticated = () => {
    return !!getAuthToken();
};
